/* eslint-disable no-restricted-properties */
// import {history} from '@RouterAdmin'
import { Promise } from 'es6-promise';
import host from './Host';
import _ from 'lodash';
import fetch from 'isomorphic-fetch';
import * as Sentry from '@sentry/react';
import { getRequestTool } from '@csx/request-util-zt';
import { message } from 'antd';
import SparkMD5 from 'spark-md5';
import { API_POST_FEATURE_TOGGLE_STATUS, API_GET_USER_CENTER_PERMISSIONS_BANS } from '@api';
import {
  LOGIN_TOKEN,
  COMMIT_TOKEN,
  setVariant,
  getVariant,
  hasVariant,
  setVariantSession,
  removeVariantSession,
  SUPPLIER_CODE,
} from '@Variant';
import calc from '@csx/calc';
import { ResourceLoader } from './loadResource';
const cacheData = {};
// const host = process.env.HOST
// console.log('____', host);

const requestTool = getRequestTool({
  successRules: [
    200, 0, 200000, 400024, 120240033, 160100186, 160100187, 160100188, 150300000, 110520564,
  ],
  fileTypes: ['excel', 'pdf'],
  host,
  useLock: false,
  headers: options => {
    const {
      config: { host },
    } = options;
    if (
      host === 'SCM' ||
      host === 'MALIANG' ||
      host === 'DEVOPS' ||
      host === 'SYSTEM' ||
      host === 'FQS'
    ) {
      return new Headers({});
    }
    if (hasVariant('fetchHeader')) {
      const userInfos = getVariant('fetchHeader');
      return new Headers({
        'supplier-code': userInfos || '',
      });
    } else if (hasVariant('useClickSupplier')) {
      const userInfos = getVariant('useClickSupplier');
      return new Headers({
        'supplier-code': userInfos.supplierCode || '',
      });
    } else if (hasVariant('defaultSupplier')) {
      const userInfos = getVariant('defaultSupplier');
      return new Headers({
        'supplier-code': userInfos.supplierCode || '',
      });
    } else if (hasVariant('userInfos')) {
      const userInfos = getVariant('userInfos') ? JSON.parse(getVariant('userInfos')) : {};
      return new Headers({
        'supplier-code': userInfos.defaultSupplier?.supplierCode || '',
      });
    }
    return new Headers({});
  },
});

const { requestUtil, generateUrl } = requestTool;
export { generateUrl };
export const storage = {
  setVariant,
  getVariant,
};

const timeout = 600000;
//页面url转化成页面id
export function getMenuId(path) {
  let menuId;
  const arr = getVariant('b2bUserMenu') || [];
  const getBansId = (arr, path) => {
    for (let i = 0; i < arr.length; i++) {
      if (`/${arr[i].path}` === path) {
        menuId = arr[i].id;
        break;
      } else if (Array.isArray(arr[i].children)) {
        getBansId(arr[i].children, path);
      }
    }
  };
  getBansId(arr, path);
  return menuId;
}

export function debounce(func, wait) {
  let timer;
  return function () {
    const context = this; // 注意 this 指向
    // eslint-disable-next-line prefer-rest-params
    const args = arguments; // arguments中存着e

    if (timer) clearTimeout(timer);

    timer = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
export const exit = (buttonPermissions, type) => {
  if (Array.isArray(buttonPermissions)) {
    return buttonPermissions.includes(type);
  } else {
    return false;
  }
};
// GBK字符集实际长度计算
export const getStrLength = str => {
  let realLength = 0;
  const len = str.length;
  let charCode = -1;
  for (let i = 0; i < len; i++) {
    charCode = str.charCodeAt(i);
    if (charCode >= 0 && charCode <= 128) {
      realLength += 1;
    } else {
      // 如果是中文则长度加2
      realLength += 2;
    }
  }
  return realLength;
};
export function removeUndefined(obj) {
  const o = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (obj[key] !== undefined) {
        o[key] = obj[key];
      }
    }
  }
  return o;
}
function hasCache(data, url, api) {
  return (
    cacheData[api.url] &&
    cacheData[api.url][api.config.method] &&
    _.isEqual(data, cacheData[api.url].data, true) &&
    _.isEqual(url, cacheData[api.url].url) &&
    _.isEqual(api, cacheData[api.url].api)
  );
}
/* 重新登陆 */
let warning = false;
function reLogin(params) {
  const hasTips = params.hasTips || true,
    // needBack = params.needBack || true,
    tips = params.tips || false;
  if (!warning) {
    warning = true;
    // let directUrl = `/${needBack ? `?backUrl=${window.location.pathname}` : ''}`
    if (hasTips) {
      message.error(tips ? tips : '当前未登录，将跳转到登录页面。');
    }
    setTimeout(() => {
      window.location.href = '/';
      warning = false;
    }, 2000);
  }
}
// export function generateUrl(api, searchParams, urlParams, replaceParams) {
//   let url = `${host[api.config.host.toLocaleUpperCase()]}${api.url}`
//   if (replaceParams) {
//     for (const key in replaceParams) {
//       if (replaceParams.hasOwnProperty(key)) {
//         const reg = new RegExp(`\\$${key}`, 'g')
//         url = url.replace(reg, replaceParams[key])
//       }
//     }
//   }
//   if (urlParams) {
//     url += `/${urlParams.join('/')}`
//   }
//   if (searchParams) {
//     url += (() => {
//       const str = []
//       for (const key in searchParams) {
//         if (
//           searchParams.hasOwnProperty(key) &&
//           searchParams[key] !== '' &&
//           searchParams[key] !== undefined
//         ) {
//           str.push(`${key}=${searchParams[key]}`)
//         }
//       }
//       return `?${str.join('&')}`
//     })()
//   }
//   // 给URL加个时间戳
//   // if (url.indexOf('?') != -1) {
//   //   url += `&t=${new Date().getTime()}`
//   // } else {
//   //   url += `?t=${new Date().getTime()}`
//   // }
//   return url
// }
function generateBody(api, data) {
  const headers = new Headers({
    Accept: 'application/json, */*',
  });
  if (api.config.host == 'CSXWMS') {
    const b2bWmsLocation = getVariant('b2bWmsLocation') || {};
    headers.append('x-location', b2bWmsLocation.value || '');
    headers.append('x-locationName', encodeURI(b2bWmsLocation.children || ''));
  }
  if (api.config.method !== 'get') {
    // 带上token
    headers.append('Content-Type', 'application/json');
  }
  if (hasVariant(LOGIN_TOKEN)) {
    headers.append(LOGIN_TOKEN, getVariant(LOGIN_TOKEN));
  }
  if (hasVariant('fetchHeader')) {
    headers.append(SUPPLIER_CODE, getVariant('fetchHeader'));
  } else if (hasVariant('useClickSupplier')) {
    const userInfos = getVariant('useClickSupplier');
    headers.append(SUPPLIER_CODE, userInfos.supplierCode);
  } else if (hasVariant('defaultSupplier')) {
    const userInfos = getVariant('defaultSupplier');
    headers.append(SUPPLIER_CODE, userInfos.supplierCode);
  } else if (hasVariant('userInfos')) {
    const userInfos = JSON.parse(getVariant('userInfos'));
    headers.append(SUPPLIER_CODE, userInfos.defaultSupplier.supplierCode);
  }

  // if (hasVariant(COMMIT_TOKEN)) {
  //   // 防重，比如下单重复提交
  //   headers.append(COMMIT_TOKEN, getVariant(COMMIT_TOKEN))
  // }
  const result = {
    method: api.config.method,
    headers,
  };
  if (data !== undefined) {
    result.body = JSON.stringify(data);
  }
  return result;
}
const otherPlaceCode = '600230'; // 异地登陆错误code
// function getApiData(options) {
//   /*
//    * author: 石志鹏
//    * createdTime: 2019/08/22
//    * 修改问题：添加后端返回的code码前端需要获取到，并且执行code码的方法，例如：returnCode: [500]等
//    */
//   const { data, searchParams, urlParams, replaceParams, api, errMessage, returnCode } = options;
//   let loginToken = null,
//     commitToken = null,
//     fileName = api.config.fileName || '导出信息';
//   const noWarn = api.config.noWarn || false,
//     url = generateUrl(api, searchParams, urlParams, replaceParams);
//   if (api.config.cache) {
//     if (hasCache(data, url, api)) {
//       return Promise.resolve(cacheData[api.url][api.config.method]);
//     }
//     cacheData[api.url] = {};
//   }

//   return new Promise((resolve, reject) => {
//     let timeOutFlag = setTimeout(() => {
//       timeOutFlag = null;
//       reject({ message: '超时' });
//     }, timeout);
//     fetch(url, generateBody(api, data))
//       .then(
//         res => {
//           if (timeOutFlag === null) {
//             return Promise.reject({});
//           }
//           clearTimeout(timeOutFlag);
//           // loginToken = res.headers.get(LOGIN_TOKEN)
//           loginToken = res.headers.get(LOGIN_TOKEN) || getVariant(LOGIN_TOKEN);
//           commitToken = res.headers.get(COMMIT_TOKEN);
//           const contentType = res.headers.get('Content-Type');

//           // 判断是否是下载文件传文件名
//           /*
//            * author: 石志鹏
//            * tips：更改getdata添加下载文件pdf类型
//            * createdTime: 2019/08/14
//            *
//            */
//           const contentDisposition = res.headers.get('Content-Disposition');
//           if (contentDisposition) {
//             if (contentType.includes('excel')) {
//               fileName =
//                 contentDisposition.match(/filename=.*(?=.xlsx)/g)[0] &&
//                 contentDisposition.match(/filename=.*(?=.xlsx)/g)[0].replace('filename=', '');
//               fileName = decodeURI(fileName);
//             }
//             //添加判断是否是pdf文件下载
//             if (contentType.includes('pdf')) {
//               fileName =
//                 contentDisposition.match(/filename=.*(?=.pdf)/g)[0] &&
//                 contentDisposition.match(/filename=.*(?=.pdf)/g)[0].replace('filename=', '');
//               fileName = decodeURI(fileName);
//             }
//           }
//           return contentType.includes('excel') || contentType.includes('pdf')
//             ? res.blob()
//             : contentType.includes('json')
//             ? res.json()
//             : {};
//         },
//         err => {
//           if (timeOutFlag === null) {
//             return Promise.reject({});
//           }
//           clearTimeout(timeOutFlag);
//           reject(err);
//           return Promise.reject(err);
//         },
//       )
//       .then(
//         data => {
//           if (api.config.cache) {
//             cacheData[api.url][api.config.method] = data;
//           }
//           if (!timeOutFlag) {
//             resolve();
//             return;
//           }
//           // 在接口设置notoken字段  允许后台接口没有token返回
//           if (
//             data.code == 600207 ||
//             data.code == 600201 ||
//             data.code == otherPlaceCode ||
//             data.code == 160100005 ||
//             data.code == 160100008 ||
//             data.code == 160100009
//           ) {
//             // 登录过期
//             sessionStorage.clear();
//             removeVariantSession(LOGIN_TOKEN);
//             removeVariantSession(COMMIT_TOKEN);
//             localStorage.removeItem('curr_shop');
//             localStorage.removeItem(LOGIN_TOKEN);
//             localStorage.removeItem(COMMIT_TOKEN);
//             reLogin({
//               hasTips: true,
//               needBack: false,
//               tips: false,
//             });
//           }
//           if (api.config.noToken !== true && loginToken) {
//             setVariant(LOGIN_TOKEN, loginToken);
//             setVariantSession(LOGIN_TOKEN, loginToken);
//             if (commitToken) {
//               // 防重，比如下单重复提交。有数据则更新
//               setVariant(COMMIT_TOKEN, commitToken);
//               setVariantSession(COMMIT_TOKEN, commitToken);
//             }
//           }
//           if (!data) {
//             message.destroy();
//             !noWarn && message.error('接口异常');
//           }
//           if (
//             (data.type && data.type.includes('excel')) ||
//             (data.type && data.type.includes('pdf'))
//           ) {
//             const a = document.createElement('a');
//             document.body.appendChild(a);
//             const url = window.URL.createObjectURL(data);
//             a.href = url;

//             //添加判断下载的文件类型支持excel和pdf
//             if (data.type.includes('excel')) {
//               a.download = `${fileName}.xlsx`;
//             } else if (data.type.includes('pdf')) {
//               a.download = `${fileName}.pdf`;
//             }
//             a.click();
//             document.body.removeChild(a);
//             // 异步导出，火狐专用
//             setTimeout(() => window.URL.revokeObjectURL(url), 0);
//             resolve();
//             return;
//           }

//           /*
//            * author: 石志鹏
//            * createdTime: 2019/08/22
//            * tips：添加后端返回的code码前端需要获取到，并且执行code码的方法，例如：returnCode: [500]等
//            * 当isReturnCode为true时则表示需要捕获到后台返回的code并加以处理
//            */
//           let isReturnCode = false;
//           if (returnCode) {
//             for (let c = 0; c < returnCode.length; c++) {
//               if (data.code == returnCode[c]) {
//                 isReturnCode = true;
//               }
//             }
//           }
//           if (
//             data.code == 200 ||
//             data.code == 0 ||
//             data.code == 200000 ||
//             data.code == 20001005 ||
//             isReturnCode
//           ) {
//             resolve(data);
//             return data;
//           } else {
//             message.destroy();
//             !noWarn && message.error(errMessage || data.message || data.desc || '未知的错误');
//             reject(data);
//             return data;
//           }
//         },
//         err => {
//           console.error(err);
//           return err;
//         },
//       );
//   });
// }
export function getData(options) {
  const { type = 'api' } = options;
  switch (type) {
    case 'api': {
      return requestUtil(options, Sentry);
    }
  }
}

export function clearEmptyParams(params) {
  const _newPar = {};
  for (const key in params) {
    if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
      _newPar[key] = params[key];
    }
  }
  return _newPar;
}

/* 判断是否为登陆页 */
export function isLoginPage() {
  return window.location.pathname == '/';
}
/*
 获取url参数
 */
export function getQueryString(name) {
  if (name == undefined || name == null || name == '') {
    // showMsg('获取参数失败');
    return false;
  }
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return decodeURI(r[2]);
  } else {
    return null;
  }
}
/* 取两位小数点 整数 - zero */
export function toFixed(number, padEnd = 2) {
  try {
    number = parseFloat(number);
    const pow = 10 ** (padEnd + 1); // Math.pow(10, padEnd)
    /*
    * fround()
      返回一个数的单精度浮点数形式
      主要用于无法用 64 个二进制位表示的小数
    * trunc()
      用于取整(非四舍五入)
      对于非数值，内部调用 Number 强转为数值
      对于空值或其他数据，返回NaN
    * round()
      用于取整(非四舍五入)
      对于非数值，内部调用 Number 强转为数值
      对于空值或其他数据，返回NaN
    */
    number = Number.isNaN(number) ? 0 : Math.round(number * pow) / pow;
  } catch (err) {
    console.error(err);
    return '0.00';
  }
  return number.toFixed(padEnd);
}
/* toFixed -zero */
// 将传入数据转换为字符串,并清除字符串中非数字与.的字符
// 按数字格式补全字符串
// 支持负数
export function getFloatStr(num = 0, padEnd = 2) {
  // Infinity 代表无穷大
  if (num === -Infinity || num === Infinity || Number.isNaN(num)) num = 0;
  if (!_.isNumber(parseFloat(num)) || !_.isNumber(parseFloat(padEnd))) {
    return console.error('arguments to type not is numner! ');
  }
  num = parseFloat(num);
  const isMinus = num < 0;
  num = _.round(Math.abs(num), padEnd);
  try {
    num += '';
    num = num.replace(/[^0-9|\.]/g, ''); //清除字符串中的非数字非.字符
    if (/^0+/.test(num)) {
      //清除字符串开头的0
      num = num.replace(/^0+/, '');
    }
    if (!/\./.test(num)) {
      //为整数字符串在末尾添加.00
      num = num.padEnd(num.length + 1, '.');
      num = num.padEnd(num.length + padEnd, '0'); // num += '.00'
    }
    if (/^\./.test(num)) {
      //字符以.开头时,在开头添加0
      num = num.padStart(num.length + 1, '0'); // num = '0' + num
    }
    num = num.padEnd(num.length + padEnd, '0'); // num += '00'        //在字符串末尾补零
    const regExp = new RegExp(`\\d+\\.\\d{${padEnd}}`);
    num = num.match(regExp)[0];
  } catch (err) {
    console.error(err);
  }
  return isMinus ? `-${num}` : num;
}
/* 幂 - zero */
// 数组扩展方法
// eslint-disable-next-line no-extend-native
Array.prototype.power = function (fun, ...callbact) {
  for (let i = 0, l = this.length; i < l; i++) {
    const j = l - i - 1;
    if (i > j) {
      break;
    }
    if (i == j) {
      fun(this[i], i);
      break;
    }
    fun(this[i], i);
    fun(this[j], j);
  }
  return this;
};
// eslint-disable-next-line no-extend-native
String.prototype.Trim = function () {
  return this.replace(/\s+/g, '');
};
export const fullScreen = () => {
  const el = document.documentElement,
    rfs =
      el.requestFullscreen ||
      el.webkitRequestFullScreen ||
      el.mozRequestFullScreen ||
      el.msRequestFullscreen;
  rfs.call(el);
};
export const isInFullScreen = () => {
  const isInFullScreen =
    (document.fullscreenElement && document.fullscreenElement !== null) ||
    (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
    (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
    (document.msFullscreenElement && document.msFullscreenElement !== null);
  return !!isInFullScreen;
};
export const toggleFullScreen = () => {
  const docElm = document.documentElement;
  if (!isInFullScreen()) {
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen();
    } else if (docElm.mozRequestFullScreen) {
      docElm.mozRequestFullScreen();
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen();
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen();
    }
  } else {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.mozCancelFullScreen) {
      document.mozCancelFullScreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  }
};
/*
 * 运算部件
 * */
export const operationalUnit = {
  // 保留几位小数点
  toFixed: (num = 0, e) => {
    try {
      const divisor = operationalUnit.changeInit(num, e);
      // eslint-disable-next-line no-restricted-properties
      num = operationalUnit.divide([divisor, Math.pow(10, e)]);
    } catch (e) {
      console.error(e);
      num = 0;
    }
    return num;
  },
  // 获取小数点位数
  getPosition: (num = 0) => {
    // 待优化
    let e = 0;
    try {
      num = parseFloat(num).toString();
      // 判断是否小于0
      // let isMinus = false
      if (num.indexOf('-') !== -1) {
        // isMinus = true
        num = Math.abs(num).toString();
      }
      if (num.includes('.') && num.indexOf('.') !== -1) {
        e = num.length - num.indexOf('.') - 1;
      }
    } catch (e) {
      console.error(e);
    }
    return e;
  },
  // 转变成整数
  changeInit: (num = 0, e) => {
    try {
      if (num == '0') return 0;
      num = parseFloat(num).toString();
      // 判断是否小于0
      let isMinus = false;
      if (num.indexOf('-') !== -1) {
        isMinus = true;
        num = Math.abs(num).toString();
      }
      // eslint-disable-next-line no-restricted-properties
      num = parseInt(Math.round(num * Math.pow(10, e)), 10); // 待优化 // '9.53' * 100
      if (isMinus) num = -num;
    } catch (e) {
      console.error(e);
      num = 0;
    }
    return num;
  },
  // 加
  add: arr => {
    if (!arr.length) return 0;
    let e = 0;
    arr.map(item => {
      const _e = operationalUnit.getPosition(item);
      e = _e > e ? _e : e;
    });
    let total = 0;
    arr.map((item, index) => {
      const num = operationalUnit.changeInit(item, e);
      if (index === 0) {
        total = num;
      } else {
        total += num;
      }
    });
    // eslint-disable-next-line no-restricted-properties
    const m = Math.pow(10, e);
    return total / m;
  },
  // 减
  cut: arr => {
    if (!arr.length) return 0;
    let e = 0;
    arr.map(item => {
      const _e = operationalUnit.getPosition(item);
      e = _e > e ? _e : e;
    });
    let total = 0;
    arr.map((item, index) => {
      const num = operationalUnit.changeInit(item, e);
      if (index === 0) {
        total = num;
      } else {
        total -= num;
      }
    });
    // eslint-disable-next-line no-restricted-properties
    const m = Math.pow(10, e);
    return total / m;
  },
  // 乘
  ride: arr => {
    if (!arr.length) return 0;
    let e = 0;
    arr.map(item => {
      const _e = operationalUnit.getPosition(item);
      e = _e > e ? _e : e;
    });
    let total = 0;
    arr.map((item, index) => {
      const num = operationalUnit.changeInit(item, e);
      if (index === 0) {
        total = num;
      } else {
        total *= num;
      }
    });
    // eslint-disable-next-line no-restricted-properties
    const m = Math.pow(10, e * arr.length);
    return total / m;
  },
  // 除
  divide: arr => {
    if (!arr.length) return 0;
    let e = 0;
    arr.map(item => {
      const _e = operationalUnit.getPosition(item);
      e = _e > e ? _e : e;
    });
    let total = 0;
    arr.map((item, index) => {
      const num = operationalUnit.changeInit(item, e);
      if (index === 0) {
        total = num;
      } else {
        total /= num;
      }
    });
    return total;
  },
};
// 获取用户按钮权限
export const getPermissionsButtonsBans = () => getVariant('permissionsButtonsBans');
// import number from 'number-precision' // 待优化

// 转换层级数据

export function changeFieldsName(data, options, codeAndId) {
  if (data.length === 0) {
    // return arr
    return [];
  }
  const restFields = [];
  data.forEach((firstItem, firstIdx) => {
    restFields.push({
      value: firstItem[options[0]],
      label: firstItem[options[1]],
      children: [],
    });
    data[firstIdx][options[2]].forEach((secondItem, secondIdx) => {
      const thredChildren = data[firstIdx][options[2]][secondIdx][options[2]];
      restFields[firstIdx].children.push({
        value:
          thredChildren.length == 0 && codeAndId
            ? `${secondItem[options[0]]}-${secondItem[options[3]]}`
            : secondItem[options[0]],
        label: secondItem[options[1]],
        children: [],
      });
      if (thredChildren.length > 0) {
        thredChildren.forEach((thirdItem, thirdIdx) => {
          restFields[firstIdx].children[secondIdx].children.push({
            value: codeAndId
              ? `${thirdItem[options[0]]}-${thirdItem[options[3]]}`
              : thirdItem[options[0]],
            label: thirdItem[options[1]],
            // children: []
          });
        });
      }
    });
  });
  return restFields;
}
//保留小数点后两位-处理js数据精度问题
export function handlePoint(num) {
  const n_ = num * 1;
  if (n_) {
    return Math.round(n_ * 100) / 100;
  } else {
    return 0;
  }
}

export const provinceTextMap = {
  1: '北京市',
  2: '上海市',
  3: '天津市',
  4: '内蒙古自治区',
  5: '山西省',
  6: '河北省',
  7: '辽宁省',
  8: '吉林省',
  9: '黑龙江省',
  10: '江苏省',
  11: '安徽省',
  12: '山东省',
  13: '浙江省',
  14: '江西省',
  15: '福建省',
  16: '福建BBC',
  17: '湖南省',
  18: '湖北省',
  19: '河南省',
  20: '广东省',
  21: '海南省',
  22: '广西壮族自治区',
  23: '贵州省',
  24: '四川省',
  25: '云南省',
  26: '陕西省',
  27: '甘肃省',
  28: '宁夏回族自治区',
  29: '青海省',
  30: '新疆维吾尔自治区',
  31: '西藏自治区',
  32: '重庆市',
};

//去除空字段(obj:需要去除的对象，fields：需要直接去掉的字段）
export function dealObjectValue(obj, fields) {
  const newObj = {};
  for (const i in obj) {
    if (obj.hasOwnProperty(i)) {
      let jud = true;
      if (fields) {
        for (let j = 0; j < fields.length; j++) {
          if (i == fields[j]) jud = false;
        }
      }
      if (obj[i] && jud) newObj[i] = obj[i];
    }
  }
  return newObj;
}

//省市联动数据
export const addressData = {
  北京市: ['北京市'],
  天津市: ['天津市'],
  河北省: [
    '石家庄市',
    '唐山市',
    '秦皇岛市',
    '邯郸市',
    '邢台市',
    '保定市',
    '张家口市',
    '承德市',
    '沧州市',
    '廊坊市',
    '衡水市',
  ],
  山西省: [
    '太原市',
    '大同市',
    '阳泉市',
    '长治市',
    '晋城市',
    '朔州市',
    '晋中市',
    '运城市',
    '忻州市',
    '临汾市',
    '吕梁市',
  ],
  内蒙古自治区: [
    '呼和浩特市',
    '包头市',
    '乌海市',
    '赤峰市',
    '通辽市',
    '鄂尔多斯市',
    '呼伦贝尔市',
    '巴彦淖尔市',
    '乌兰察布市',
    '兴安盟',
    '锡林郭勒盟',
    '阿拉善盟',
  ],
  辽宁省: [
    '沈阳市',
    '大连市',
    '鞍山市',
    '抚顺市',
    '本溪市',
    '丹东市',
    '锦州市',
    '营口市',
    '阜新市',
    '辽阳市',
    '盘锦市',
    '铁岭市',
    '朝阳市',
    '葫芦岛市',
  ],
  吉林省: [
    '长春市',
    '吉林市',
    '四平市',
    '辽源市',
    '通化市',
    '白山市',
    '松原市',
    '白城市',
    '延边朝鲜族自治州',
  ],
  黑龙江省: [
    '哈尔滨市',
    '齐齐哈尔市',
    '鸡西市',
    '鹤岗市',
    '双鸭山市',
    '大庆市',
    '伊春市',
    '佳木斯市',
    '七台河市',
    '牡丹江市',
    '黑河市',
    '绥化市',
    '大兴安岭地区',
  ],
  上海市: ['上海市'],
  江苏省: [
    '南京市',
    '无锡市',
    '徐州市',
    '常州市',
    '苏州市',
    '南通市',
    '连云港市',
    '淮安市',
    '盐城市',
    '扬州市',
    '镇江市',
    '泰州市',
    '宿迁市',
  ],
  浙江省: [
    '杭州市',
    '宁波市',
    '温州市',
    '嘉兴市',
    '湖州市',
    '绍兴市',
    '金华市',
    '衢州市',
    '舟山市',
    '台州市',
    '丽水市',
  ],
  安徽省: [
    '合肥市',
    '芜湖市',
    '蚌埠市',
    '淮南市',
    '马鞍山市',
    '淮北市',
    '铜陵市',
    '安庆市',
    '黄山市',
    '滁州市',
    '阜阳市',
    '宿州市',
    '六安市',
    '亳州市',
    '池州市',
    '宣城市',
  ],
  福建省: [
    '福州市',
    '厦门市',
    '莆田市',
    '三明市',
    '泉州市',
    '漳州市',
    '南平市',
    '龙岩市',
    '宁德市',
  ],
  江西省: [
    '南昌市',
    '景德镇市',
    '萍乡市',
    '九江市',
    '新余市',
    '鹰潭市',
    '赣州市',
    '吉安市',
    '宜春市',
    '抚州市',
    '上饶市',
  ],
  山东省: [
    '济南市',
    '青岛市',
    '淄博市',
    '枣庄市',
    '东营市',
    '烟台市',
    '潍坊市',
    '济宁市',
    '泰安市',
    '威海市',
    '日照市',
    '莱芜市',
    '临沂市',
    '德州市',
    '聊城市',
    '滨州市',
    '菏泽市',
  ],
  河南省: [
    '郑州市',
    '开封市',
    '洛阳市',
    '平顶山市',
    '安阳市',
    '鹤壁市',
    '新乡市',
    '焦作市',
    '濮阳市',
    '许昌市',
    '漯河市',
    '三门峡市',
    '南阳市',
    '商丘市',
    '信阳市',
    '周口市',
    '驻马店市',
  ],
  湖北省: [
    '武汉市',
    '黄石市',
    '十堰市',
    '宜昌市',
    '襄阳市',
    '鄂州市',
    '荆门市',
    '孝感市',
    '荆州市',
    '黄冈市',
    '咸宁市',
    '随州市',
    '恩施土家族苗族自治州',
  ],
  湖南省: [
    '长沙市',
    '株洲市',
    '湘潭市',
    '衡阳市',
    '邵阳市',
    '岳阳市',
    '常德市',
    '张家界市',
    '益阳市',
    '郴州市',
    '永州市',
    '怀化市',
    '娄底市',
    '湘西土家族苗族自治州',
  ],
  广东省: [
    '广州市',
    '韶关市',
    '深圳市',
    '珠海市',
    '汕头市',
    '佛山市',
    '江门市',
    '湛江市',
    '茂名市',
    '肇庆市',
    '惠州市',
    '梅州市',
    '汕尾市',
    '河源市',
    '阳江市',
    '清远市',
    '东莞市',
    '中山市',
    '潮州市',
    '揭阳市',
    '云浮市',
  ],
  广西壮族自治区: [
    '南宁市',
    '柳州市',
    '桂林市',
    '梧州市',
    '北海市',
    '防城港市',
    '钦州市',
    '贵港市',
    '玉林市',
    '百色市',
    '贺州市',
    '河池市',
    '来宾市',
    '崇左市',
  ],
  海南省: ['海口市', '三亚市', '三沙市', '儋州市'],
  重庆市: ['重庆市'],
  四川省: [
    '成都市',
    '自贡市',
    '攀枝花市',
    '泸州市',
    '德阳市',
    '绵阳市',
    '广元市',
    '遂宁市',
    '内江市',
    '乐山市',
    '南充市',
    '眉山市',
    '宜宾市',
    '广安市',
    '达州市',
    '雅安市',
    '巴中市',
    '资阳市',
    '阿坝藏族羌族自治州',
    '甘孜藏族自治州',
    '凉山彝族自治州',
  ],
  贵州省: [
    '贵阳市',
    '六盘水市',
    '遵义市',
    '安顺市',
    '毕节市',
    '铜仁市',
    '黔西南布依族苗族自治州',
    '黔东南苗族侗族自治州',
    '黔南布依族苗族自治州',
  ],
  云南省: [
    '昆明市',
    '曲靖市',
    '玉溪市',
    '保山市',
    '昭通市',
    '丽江市',
    '普洱市',
    '临沧市',
    '楚雄彝族自治州',
    '红河哈尼族彝族自治州',
    '文山壮族苗族自治州',
    '西双版纳傣族自治州',
    '大理白族自治州',
    '德宏傣族景颇族自治州',
    '怒江傈僳族自治州',
    '迪庆藏族自治州',
  ],
  西藏自治区: ['拉萨市', '日喀则市', '昌都市', '林芝市', '山南市', '那曲地区', '阿里地区'],
  陕西省: [
    '西安市',
    '铜川市',
    '宝鸡市',
    '咸阳市',
    '渭南市',
    '延安市',
    '汉中市',
    '榆林市',
    '安康市',
    '商洛市',
  ],
  甘肃省: [
    '兰州市',
    '嘉峪关市',
    '金昌市',
    '白银市',
    '天水市',
    '武威市',
    '张掖市',
    '平凉市',
    '酒泉市',
    '庆阳市',
    '定西市',
    '陇南市',
    '临夏回族自治州',
    '甘南藏族自治州',
  ],
  青海省: [
    '西宁市',
    '海东市',
    '海北藏族自治州',
    '黄南藏族自治州',
    '海南藏族自治州',
    '果洛藏族自治州',
    '玉树藏族自治州',
    '海西蒙古族藏族自治州',
  ],
  宁夏回族自治区: ['银川市', '石嘴山市', '吴忠市', '固原市', '中卫市'],
  新疆维吾尔自治区: [
    '乌鲁木齐市',
    '克拉玛依市',
    '吐鲁番市',
    '哈密市',
    '昌吉回族自治州',
    '博尔塔拉蒙古自治州',
    '巴音郭楞蒙古自治州',
    '阿克苏地区',
    '克孜勒苏柯尔克孜自治州',
    '喀什地区',
    '和田地区',
    '伊犁哈萨克自治州',
    '塔城地区',
    '阿勒泰地区',
  ],
  台湾省: [],
  香港特别行政区: [],
  澳门特别行政区: [],
};
//数字转汉语大写
export function digitUppercase(n) {
  const fraction = ['角', '分'];
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  const head = n < 0 ? '欠' : '';
  n = Math.abs(n);
  let s = '';
  const xiaoshu = n?.toString()?.split('.')?.[1] || '';
  for (let i = 0; i < fraction.length; i++) {
    // const index = Math.floor(n * 10 * Math.pow(10, i)) % 10;
    const index = xiaoshu?.[i] || 0;
    s += (digit[index] + fraction[i]).replace(/零./, '');
  }
  s = s || '整';
  n = Math.floor(n);
  for (let i = 0; i < unit[0].length && n > 0; i++) {
    let p = '';
    for (let j = 0; j < unit[1].length && n > 0; j++) {
      p = digit[n % 10] + unit[1][j] + p;
      n = Math.floor(n / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }
  return (
    head +
    s
      .replace(/(零.)*零元/, '元')
      .replace(/(零.)+/g, '零')
      .replace(/^整$/, '零元整')
  );
}

//去除特殊字符或者一些字符串的操作
export function stripscript(s) {
  const pattern = new RegExp(
    "[`~!@#$^&*()=|{}':;'\\[\\].<>/?~！@#￥……&*（）&mdash;—|{}【】‘；：”“'。，、？%]",
  );
  let rs = '';
  for (let i = 0; i < s.length; i++) {
    rs += s.substr(i, 1).replace(pattern, '');
  }
  return rs;
}

//去除字符串中所有的空格
export function removeSpaces(str) {
  const str_1 = str.replace(/\s*/g, '');
  return str_1;
}

//返回需要的状态
export function returnNeedState(str, arr, key, value) {
  let state = '';
  arr.map((item, index) => {
    if (key && value) {
      if (item[key] == str) state = item[value];
    } else {
      if (item[0] == str) state = item[1];
    }
  });
  return state;
}

// 删除末尾0, 并且最多显示4为小数
export const changeNumShow = value => {
  if (!value && value !== 0) {
    return null;
  }
  const val = Number(value).toString();
  if (val.includes('.')) {
    const valArr = val.split('.');
    const beforeNumber = valArr[0];
    const afterNumver = valArr[1].slice(0, 4).replace(/0+$/g, '');
    if (afterNumver) {
      return `${beforeNumber}.${afterNumver}`;
    } else {
      return beforeNumber;
    }
  } else {
    return val;
  }
};

//符合粘贴excle自动加逗号
export function onchangeInputValue(val) {
  const str1 = val; //excle数据字符串
  let res = '';
  for (const q of str1) {
    if (escape(q) == '%09' || escape(q) == '%20') {
      res += ',';
      // eslint-disable-next-line no-continue
      continue;
    } else {
      res += q;
    }
  }
  return res;
}

// 新的导出
export const newExportFunc = res =>
  new Promise((reslove, reject) => {
    if (!res) {
      console.error('返回值为空--');
    }
    if (res && res.code === 200) {
      const { result } = res;
      const a = document.createElement('a');
      document.body.appendChild(a);
      const url = result;
      a.href = url;
      a.click();
      document.body.removeChild(a);
      // 异步导出，火狐专用
      setTimeout(() => window.URL.revokeObjectURL(url), 0);
      reslove();
    } else {
      reject();
    }
  });

// 获取表格宽度
export const getTableColumnsWidth = data => {
  let newWidth = 0;
  if (!data) {
    return false;
  }
  if (Array.isArray(data)) {
    data.forEach(item => {
      newWidth += item.width;
    });
  }
  return newWidth;
};

// 环境（1开发 2SIT 3预发 4生产）
const envEnum = {
  development: 1,
  test: 1,
  sit: 2,
  pre: 3,
  production: 4,
};
/**
 * @description:  请求特性开关
 * @return {Promise<boolean>}
 * @param {*} switchKey 特性开关key
 * @param {*} txProjectName  特性开关项目名
 * @param {*} txProjectName  特性开关项目名
 */
export const getDevopsSwitchStatus = (switchKey, txProjectName = 'scc') => {
  if (!txProjectName || !switchKey) {
    return Promise.resolve(false);
  }
  const env = process.env.CSX_FE_PUBLIC_DEVOPS_ENV || 1;

  return getData({ api: API_POST_FEATURE_TOGGLE_STATUS, data: { txProjectName, switchKey, env } })
    .then(res => {
      const status = _.get(res, 'data');
      localStorage.setItem(switchKey, status);

      return status;
    })
    .catch(() => localStorage.getItem(switchKey))
    .then(status => calc(status).eq(1));
};

export const getFeatureStatus = async (switchKey, txProjectName = 'scc') => {
  //开关状态（0-关闭 1-开启 2-不存在）

  let status = 2;
  try {
    const res = await getData({
      api: API_POST_FEATURE_TOGGLE_STATUS,
      data: { switchKey, txProjectName, env: process.env.CSX_FE_PUBLIC_DEVOPS_ENV || 4 },
    });
    status = res.data;
  } catch (error) {
    console.log(error);
  }

  return status === 1 ? true : false;
};

/**
 * @description 生成str
 * @param {(?string | ?number)}  texts 字符串数组
 * @param {string} tag 分隔符
 * @returns 字符串
 * @example spliceString('abcd', '-')
 */
export const fileToMd5 = file => {
  return new Promise((resolve, reject) => {
    try {
      if (typeof file === 'string' || typeof file === 'number') {
        resolve(SparkMD5.hash(file));
      }
      if (Array.isArray(file)) {
        reject('入参不支持数组');
      }
      const blobSlice =
        File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice,
        chunkSize = 2097152, // 超过2m开始分片
        chunks = Math.ceil(file.size / chunkSize),
        spark = new SparkMD5.ArrayBuffer(),
        fileReader = new FileReader();
      let currentChunk = 0;
      function loadNext() {
        const start = currentChunk * chunkSize,
          end = start + chunkSize >= file.size ? file.size : start + chunkSize;

        fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
      }

      fileReader.onerror = function () {
        console.warn('fileReader加载文件失败');
        reject('fileReader加载文件失败');
      };
      fileReader.onload = function (e) {
        spark.append(e.target.result); // Append array buffer
        currentChunk++;

        if (currentChunk < chunks) {
          loadNext();
        } else {
          resolve(spark.end());
        }
      };
      loadNext();
    } catch (error) {
      reject(error);
    }
  });
};

// 扁平化数据
export const platFn = (list, parentName, prvoName) => {
  let res = [];
  if (list[0].level === 2) {
    list.forEach(item => {
      item.parentName = parentName;
      item.prvoName = prvoName;
    });
  }
  res = list.concat(
    ...list
      .map(item => {
        if (item.children instanceof Array && item.children.length > 0) {
          item.parentName = parentName;
          if (item.level === 1) {
            return platFn(item.children, item.name, parentName);
          } else {
            return platFn(item.children, item.name);
          }
        }
        return null;
      })
      .filter(o => o instanceof Array && o.length > 0),
  );
  return res;
};

export const reloadFunc = () => {
  const reloadNum = localStorage.getItem('reloadNum');
  if (reloadNum && Number(reloadNum) === 2) {
    window.location.replace('/');
  } else {
    typeof reloadNum === 'object'
      ? localStorage.setItem('reloadNum', 1)
      : localStorage.setItem('reloadNum', reloadNum * 1 + 1);
    window.location.reload();
  }
};

export const getButtonPermissions = async path => {
  if (!path) {
    return false;
  }
  const id = getMenuId(path);
  if (!id) {
    return false;
  }
  try {
    const data = await getData({ api: API_GET_USER_CENTER_PERMISSIONS_BANS, urlParams: [id] });
    if (data.code === 200000) {
      const buttonPermissions = data.data.map(item => item.menuCode);
      return buttonPermissions;
    }
    return [];
  } catch (e) {
    console.log(e);
  }
};
//封装一个获取按钮级别权限方法
export function getUcenterBans(pathname, callBack) {
  let menuId;
  const arr = getVariant('b2bUserMenu') || [];

  // 当用户在浏览器中,同时打开项目A、项目B的时候,在项目B中退出登录,保持项目A页面不刷新,此时项目A的菜单数据是被清空了的
  // 这导致了点击项目A中,获取页面的菜单id的时候,是获取不到的,导致请求页面的按钮权限时,接口由于id缺失,报404
  // 解决方案: 在检测到页面的菜单数据不是数组的时候,将页面重新加载
  if (!Array.isArray(arr)) {
    window.location.reload();
    console.log('没有获取页面数据, 准备重新加载页面');
    return '';
  }
  if (!arr.length) {
    console.log('获取页面数据长度为零');
    return '';
  }
  const getBansId = (arr, pathname) => {
    for (let i = 0; i < arr.length; i++) {
      if (`/${arr[i].path}` === pathname) {
        menuId = arr[i].id;
        break;
      } else if (Array.isArray(arr[i].children)) {
        getBansId(arr[i].children, pathname);
      }
    }
    return menuId;
  };
  const bansID = getBansId(arr, pathname);
  bansID &&
    getData({ api: API_GET_USER_CENTER_PERMISSIONS_BANS, urlParams: [bansID] }).then(res => {
      // 页面按钮 级别的权限
      if (res && res.code === 200000) {
        callBack && callBack(res);
      }
    });
}

// 获取默认供应商Code
export function getSupplierCode() {
  if (hasVariant('fetchHeader')) {
    return getVariant('fetchHeader');
  } else if (hasVariant('useClickSupplier')) {
    return getVariant('useClickSupplier')?.supplierCode;
  } else if (hasVariant('defaultSupplier')) {
    return getVariant('defaultSupplier')?.supplierCode;
  } else if (hasVariant('userInfos')) {
    const userInfos = JSON.parse(getVariant('userInfos'));
    return userInfos?.defaultSupplier?.supplierCode;
  }
}
// 获取默认供应商票核开关
export function setSupplierCodePiaoSwitch(bool) {
  setVariant('piaoHeSwitch', bool);
}

// 获取默认供应商票核开关
export function getSupplierCodePiaoSwitch() {
  if (hasVariant('piaoHeSwitch')) {
    return getVariant('piaoHeSwitch');
  }
  return false;
}

// 获取默认供应商Name
export function getSupplierName() {
  if (hasVariant('useClickSupplier')) {
    return getVariant('useClickSupplier')?.supplierName;
  } else if (hasVariant('defaultSupplier')) {
    return getVariant('defaultSupplier')?.supplierName;
  } else if (hasVariant('userInfos')) {
    const userInfos = JSON.parse(getVariant('userInfos'));
    return userInfos.defaultSupplier?.supplierName;
  }
}

// 获取默认供应商code+name
export function getSupplierData() {
  if (hasVariant('useClickSupplier')) {
    return getVariant('useClickSupplier');
  } else if (hasVariant('defaultSupplier')) {
    return getVariant('defaultSupplier');
  } else if (hasVariant('userInfos')) {
    const userInfos = JSON.parse(getVariant('userInfos'));
    return userInfos?.defaultSupplier;
  }
}

/**
 * 获取设计器地址
 * @returns {{designer: string;printer: string}} 设计器地址
 */
export function getDesignerHost() {
  switch (process.env.RUN_ENV) {
    case 'development':
      return {
        designer: 'http://localhost:8888/index-debug.html',
        printer: 'http://localhost:8888/print-debug.html',
        env: 'devw',
      };
    case 'test':
      return {
        designer: '/maliang/index.html',
        printer: '/maliang/print.html',
        env: 'testw',
      };
    case 'sit':
      return {
        designer: '/maliang/index.html',
        printer: '/maliang/print.html',
        env: 'sitw',
      };
    case 'pre':
      return {
        designer: '/maliang/index.html',
        printer: '/maliang/print.html',
        env: 'prew',
      };

    case 'production':
    default:
      return {
        designer: '/maliang/index.html',
        printer: '/maliang/print.html',
        env: 'prodw',
      };
  }
}
// /**
//  * 获取设计器地址
//  * @returns {{designer: string;printer: string}} 设计器地址
//  */
// export function getDesignerHost() {
//   return {
//     designer: '/maliang/index.html',
//     printer: '/maliang/print.html',
//   };
// }

const projectCode = 'scc';

export function isGSS() {
  return projectCode === 'gss';
}

/**
 * 百度地图SDK 缓存，防止反复init
 */
export function initAmapSingle() {
  let cbfnArr = [];
  return function (cbfn) {
    if (window.BMapGL && window.loaded) {
      cbfn && cbfn(window.BMapGL);
      console.log('window.BMapGL had allready loaded');
    } else {
      if (document.getElementById('BMapScript')) {
        cbfnArr.push(cbfn);
      } else {
        const resources = [
          {
            type: 'js',
            url: 'https://api.map.baidu.com/api?type=webgl&v=1.0&ak=SQXpbZzMzjGuGwGN3OErB9WilhS5dbx0&callback=init',
          },
        ];

        const resourcesPlugin = [
          {
            type: 'js',
            url: 'https://api.map.baidu.com/library/CurveLine/1.5/src/CurveLine.min.js',
          },
        ];

        cbfnArr.push(cbfn);
        ResourceLoader.loadResources(resources);

        window.init = () => {
          ResourceLoader.loadResources(resourcesPlugin)
            .then(() => {
              console.log('所有资源加载完成');
              window.loaded = true;
              cbfnArr.forEach(cnfbitem => {
                cnfbitem && cnfbitem(window.BMapGL);
              });
              cbfnArr = [];
            })
            .catch(err => console.error('资源加载失败:', err));
        };

        // const url =
        //   'https://api.map.baidu.com/api?type=webgl&v=1.0&ak=SQXpbZzMzjGuGwGN3OErB9WilhS5dbx0&callback=init';
        // const jsapi = document.createElement('script');
        // jsapi.charset = 'utf-8';
        // jsapi.type = 'text/javascript';
        // jsapi.src = url;
        // jsapi.id = 'BMapScript';
        // document.head.appendChild(jsapi);

        // const jsapiA = document.createElement('script');
        // jsapiA.charset = 'utf-8';
        // jsapiA.type = 'text/javascript';
        // jsapiA.src = 'https://api.map.baidu.com/library/CurveLine/1.5/src/CurveLine.min.js';
        // jsapiA.id = 'BMapScriptA';
        // document.head.appendChild(jsapiA);

        // // 地图加载完回调
        // window.init = () => {
        //   cbfnArr.forEach(cnfbitem => {
        //     cnfbitem && cnfbitem(window.BMapGL);
        //   });
        //   cbfnArr = [];
        // };
      }
    }
  };
}

/**
 * 返回对象里的value值 处理接口参数
 * @param {*} params 参数对象
 * @return {object} 返回处理后的json
 */
export const getParamsValue = params => {
  const newParams = {};
  _.mapValues(params, (value, key) => {
    if (_.isPlainObject(value)) {
      newParams[key] = _.get(value, 'value');
    } else {
      newParams[key] = value;
    }
  });
  return newParams;
};

/**
 * @description 根据枚举key取value
 * @param {array} enumeration 枚举值
 * @param {number | string} key
 */
export const getEnumValueText = (enumeration, key) => {
  if (!enumeration || (!key && key !== 0)) {
    return console.warn('enumeration || value 不能为空');
  }

  if (!_.isArray(enumeration) || !_.size(enumeration)) {
    return console.warn('enumeration不能为空数组');
  }

  const curData = _.find(enumeration, item => {
    return item.key === key;
  });

  return _.get(curData, 'value', '');
};

const shouldShowDesensitize = value => {
  const reg = /^(KH[\da-zA-Z]{32})$/;
  return value === '****' || reg.test(value);
};

export const getBMapLabelDom = ({ customerName, labelId }) => {
  const dom = shouldShowDesensitize(customerName)
    ? `<div style="display:inline-block;" id="${labelId}"><a>${'****'}</a>
      <span
        class="onclickBtn"
        onclick="window.handleMapDesensitizeClick('${customerName}', '${labelId}', event)"
        data-secid="${customerName}"
        style="cursor:pointer;color:#1890ff;margin-left:5px;">
        查看
      </span></div>`
    : `<div id="${labelId}"><a>${customerName}</a></div>`;

  return dom;
};

export const benchmarkingList = [
  { key: 0, value: '无' },
  { key: 1, value: '京东自营旗舰店' },
  { key: 2, value: '天猫官方旗舰店' },
  { key: 4, value: '京东非自营品牌旗舰店' },
  { key: 5, value: '天猫超市' },
];

export const logisticsTypeDisabledList = [
  { key: 0, value: '常规品' },
  { key: 1, value: '自产农产品' },
  { key: 2, value: '盒饭' },
  { key: 3, value: '组合商品' },
];
export const getBenchmarkingName = key => {
  const item = benchmarkingList.find(item => item.key === Number(key));
  return item ? item.value : undefined;
};
